import React from "react";
import Modal from "react-modal";
//import Inc from "./Include";
import './Hello.scss';

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.5)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"280px",
		minHeight:"420px",
		transform: "translate(-50%, -50%)"
	}
};

function Guide ({close,isOpen}){
    const afterOpenModal = ()=>{
		
    }

    return (
		<Modal
			isOpen={isOpen}
			onRequestClose={close}
			onAfterOpen={afterOpenModal}
			style={customStyles}
			shouldCloseOnOverlayClick={true}
		>
		<div id="hello">
			<div className="face">
				<i className="fas fa-fish"></i> 遊び方
			</div>
            <div className="text">
                <p>あらゆる出来事に二択で答える冒険です。あなたの選んだ選択肢によって仲間たちが去ってしまいますので、なるべく大勢に支持されそうな方を選びましょう。</p>
                <p className="hint">※ついてきてくれる仲間が0人になると、赤い悪夢に襲われて冒険は終わります。</p>
                <p className="hint">※仲間たちはほかの誰かがが実際にプレイしたキャラクターです。</p>
            </div>
            <div className="btns">
                <button
                    className="ok"
                    onClick={close}
                >良い</button>
            </div>

		</div>
		</Modal>
	);
}

export default Guide;